/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Machines_ErrorInputs */

const vi_station_machines_error = /** @type {(inputs: Station_Machines_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mất dữ liệu máy vò — kiểm tra kết nối hoặc quyền truy cập`)
};

/**

* @param {Station_Machines_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_machines_error = /** @type {((inputs?: Station_Machines_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Machines_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_machines_error(inputs)
});